import StockOverview from "./StockOverview";

export default function InventoryMovements() {
  return (
    <StockOverview
      title="Inventory Movements"
      subtitle="Review inbound, outbound, reservation, and adjustment history from a dedicated inventory ledger."
      initialTab="movements"
      lockedTab="movements"
      showOpenWork={false}
      showAdjustAction={false}
      showReceiveAction={false}
      historyTitle="Movement History"
    />
  );
}
